module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-from-left-a937b5f4d24eee538ebbdf960b1d0340.svg";